import React, { useEffect, useRef, useState } from "react";
import { useFetch } from "services/hooks/useFetch";
import * as Mui from "@mui/material";
import { checkEditorPermission } from "services/utils/HelperFunction";
import { useDispatch } from "react-redux";
import { setGlobalSearchValue } from "services/Redux/userToken";
import { userRoleSearchKey } from "pages/Administration/AdministrationHeaders";
import { GlobalDialogBox } from "components/GlobalDialogBox";
import { CustomButton } from "components/CustomComponents";
import { rowEndStyle } from "services/constants/Styles";
import sessionHandling from "services/utils/notificationUtils";
import { useSelector } from "react-redux";
import { Loader } from "components/Loader";
import { showToast } from "services/utils/Status";
import { Delete, Edit } from "@mui/icons-material";
import { InfoMessage } from "components/CustomComponents/CustomButton";
import {
  scrollTop,
  tableRowSx,
  tableCellFontSize,
  themes,
} from "services/constants";
export const UserRole = ({ setScreenNavigation, setEditRowDetails }) => {
  const [listViewPage, setListViewPage] = useState(0);
  const { domain, token, globalSearchValue, userScreenAccess } = useSelector(
    (state) => state.tokenReducer
  );
  const dispatch = useDispatch();
  const [firstTimeTrigger, setFristTimeTrigger] = useState(true);
  const [openDialogBox, setOpenDialogBox] = useState(false);
  const [deleteRoleDetails, setDeleteRowDetails] = useState({});
  const [productRolesDetails, setProductRolesDetails] = useState([]);
  let check_access = checkEditorPermission(
    userScreenAccess?.module_details,
    "Roles & User Group",
    "Roles"
  );

  const {
    result: productRoles,
    loading,
    setLoad,
  } = useFetch(`${domain}product-control/roles/summary/`);

  useEffect(() => {
    if (!loading && firstTimeTrigger) {
      setProductRolesDetails(productRoles);
      setFristTimeTrigger(false);
    }
  }, [firstTimeTrigger, loading, productRoles]);

  const tableContainerRef = useRef(null);

  const [rowsPerPage, setRowsPerPage] = useState(25);

  const handleChangePage = (event, newPage) => {
    setListViewPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setListViewPage(0);
  };

  useEffect(() => {
    scrollTop(tableContainerRef);
  }, [listViewPage]);

  const deleteRole = async (item) => {
    try {
      const response = await fetch(
        `${domain}product-control/roles/delete/?role_id=${item?.role_id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
        }
      );
      const res = await response.json();
      if (response.ok) {
        showToast("error", "The role was deleted successfully.");
        setLoad(true);
      } else if (response.status === 409) {
        sessionHandling();
      } else {
        throw new Error(res.error);
      }
    } catch (error) {
      showToast("error", error.message);
    }
  };

  useEffect(() => {
    const filteredResults = productRoles.filter((item) =>
      userRoleSearchKey.some((key) =>
        item[key]
          ?.toString()
          .toLowerCase()
          .includes(globalSearchValue.toString().toLowerCase())
      )
    );
    setProductRolesDetails(filteredResults);
  }, [globalSearchValue, productRoles, firstTimeTrigger]);

  return loading ? (
    <Loader />
  ) : (
    <React.Fragment>
      <Mui.TableContainer
        ref={tableContainerRef}
        sx={{ m: 1, width: "100%", maxHeight: 780 }}
      >
        <Mui.Table className="border">
          <Mui.TableHead
            sx={{
              backgroundColor: themes.primary,
              position: "sticky",
              top: -1,
              zIndex: 10,
            }}
          >
            <Mui.TableRow maxWidth="xl" align="left" sx={tableRowSx}>
              <Mui.TableCell
                sx={{
                  color: themes.headLine,
                  fontWeight: "bold",
                  fontSize: tableCellFontSize,
                }}
              >
                Role
              </Mui.TableCell>
              <Mui.TableCell
                sx={{
                  color: themes.headLine,
                  fontWeight: "bold",
                  fontSize: tableCellFontSize,
                }}
              >
                Modules
              </Mui.TableCell>
              <Mui.TableCell
                sx={{
                  color: themes.headLine,
                  fontWeight: "bold",
                  fontSize: tableCellFontSize,
                }}
              >
                Action
              </Mui.TableCell>
            </Mui.TableRow>
          </Mui.TableHead>
          <Mui.TableBody>
            {productRolesDetails.length === 0 ? (
              <InfoMessage dataLength={productRoles} />
            ) : (
              productRolesDetails
                ?.slice(
                  listViewPage * rowsPerPage,
                  listViewPage * rowsPerPage + rowsPerPage
                )
                ?.map((item, index) => (
                  <Mui.TableRow
                    maxWidth="xl"
                    align="left"
                    sx={{
                      cursor: "pointer",
                      "& .MuiTableCell-root": {
                        height: "10px",
                        padding: "3px 15px",
                      },
                    }}
                  >
                    <Mui.TableCell>{item?.role_name}</Mui.TableCell>
                    <Mui.TableCell>
                      {item?.products.map((data) => data + " ")}
                    </Mui.TableCell>
                    <Mui.TableCell>
                      <Mui.IconButton
                        onClick={() => {
                          if (check_access) {
                            dispatch(setGlobalSearchValue(""));
                            setEditRowDetails(item);
                            setScreenNavigation("Edit Role");
                          } else {
                            showToast(
                              "error",
                              "Access denied: You are not authorized to edit the role"
                            );
                          }
                        }}
                      >
                        <Edit />
                      </Mui.IconButton>
                      &nbsp;
                      <Mui.IconButton
                        onClick={() => {
                          if (check_access) {
                            setDeleteRowDetails(item);
                            setOpenDialogBox(true);
                          } else {
                            showToast(
                              "error",
                              "Access denied: You are not authorized to delete the role"
                            );
                          }
                        }}
                      >
                        <Delete />
                      </Mui.IconButton>
                    </Mui.TableCell>
                  </Mui.TableRow>
                ))
            )}
          </Mui.TableBody>
        </Mui.Table>
      </Mui.TableContainer>
      <Mui.Grid container sx={{ ...rowEndStyle }}>
        {" "}
        {productRolesDetails.length > 25 && (
          <Mui.TablePagination
            className="custom-pagination"
            component="div"
            rowsPerPageOptions={[25, 50, 75, 100]}
            count={productRolesDetails.length}
            rowsPerPage={rowsPerPage}
            page={listViewPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        )}
      </Mui.Grid>

      <GlobalDialogBox
        open={openDialogBox}
        handleCloseDialog={() => {
          setOpenDialogBox(false);
        }}
        title={"Warning"}
        minWidth={550}
      >
        <Mui.Grid container>
          <Mui.Typography sx={{ fontSize: 20 }}>
            Are you sure you want to delete this user role?
          </Mui.Typography>
          <Mui.Grid container sx={{ ...rowEndStyle, paddingTop: 1 }}>
            <CustomButton
              actionFuntion={() => {
                setOpenDialogBox(false);
              }}
              actionName="No"
              typeName="button"
            />
            &nbsp;
            <CustomButton
              actionFuntion={() => {
                deleteRole(deleteRoleDetails);
                setOpenDialogBox(false);
              }}
              actionName="Yes"
              typeName="button"
            />{" "}
          </Mui.Grid>
        </Mui.Grid>
      </GlobalDialogBox>
    </React.Fragment>
  );
};
